import { useEffect, useState } from "react";
import "./App.css";
import Header from "./Sections/Header";
import Home from "./Sections/Home";
import About from "./Sections/About";
import Price from "./Sections/Price";
import Answers from "./Sections/Answers";
import Footer from "./Sections/Footer";
import { Routes, Route, useLocation } from "react-router-dom";
import Redirect from "./Shared/Redirect";
import TermsOfUse from "./Shared/TermOfUse";
import Whatsapp from "./Sections/Whatsapp";
import Comparison from "./Sections/Comparison";
import Painel from "./Sections/Painel";
import Button from "./Components/Button";
import LogoWpp from "./assets/images/whatsapp.webp";
import TestFree from "./Sections/TestFree";
import Video from "./Sections/Video";
import VideosPage from "./Tutorials";

function App() {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState<any>(null);
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    if (location.key !== "default") {
      // só quando é navegação, não reload
      const hash = location.hash;
      if (hash) {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
  }, [location]);

  // remover botao começar agora do inicio no celular

  const redirect = () => {
    window.location.href = "/redirect";
  };

  useEffect(() => {
    const sections = document.querySelectorAll('div[id^="section-"]');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        rootMargin: "-50% 0px -50% 0px",
        threshold: 0,
      }
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  const sectionColors: any = {
    "section-1": "#E4DA1B",
    "section-2": "#6125E5",
    "section-3": "#E4DA1B",
    "section-4": "#6125E5",
    "section-5": "#E4DA1B",
    "section-6": "#E4DA1B",
    "section-7": "#E4DA1B",
    "section-8": "#E4DA1B",
    "section-9": "#E4DA1B",
    "section-10": "#6125E5",
  };

  const getWppColor = () => sectionColors[activeSection] || "#6125E5";

  const goToWhatsapp = () => {
    const msg = encodeURIComponent(
      "Olá! Vim pelo site e gostaria de mais informações."
    );
    window.open(`https://wa.me/5598984131269?text=${msg}`, "_blank");
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <Header />
            <Home />
            <About />
            <Video />
            {isMobile && (
              <Button
                onClick={redirect}
                style={{ color: "#000", width: "80%", margin: "40px auto" }}
              >
                Começar agora
              </Button>
            )}
            <Comparison />
            <Painel />
            {isMobile && (
              <Button
                onClick={redirect}
                style={{ color: "#000", width: "80%", margin: "40px auto" }}
              >
                Começar agora
              </Button>
            )}
            <Whatsapp />
            <TestFree />
            <Answers />
            {isMobile && (
              <Button
                onClick={redirect}
                style={{ color: "#000", width: "80%", margin: "40px auto" }}
              >
                Começar agora
              </Button>
            )}
            <Price />
            <Footer />
            <div
              style={{
                position: "fixed",
                bottom: 10,
                right: 10,
                zIndex: 99999999999,
              }}
            >
              <Button
                style={{
                  padding: 10,
                  background: getWppColor(),
                  transition: "background 0.25s ease",
                  boxShadow: '0 0px 10px rgba(0, 0, 0, 0.35)'
                }}
                onClick={() => {
                  goToWhatsapp();
                }}
              >
                <img
                  src={LogoWpp}
                  alt="whatsapp"
                  style={{ width: 30, height: 30 }}
                />
              </Button>
            </div>
          </>
        }
      />
      <Route
        path="/term-of-use"
        element={
          <>
            <Header />
            <TermsOfUse />
          </>
        }
      />
      <Route
        path="/redirect"
        element={
          <>
            <Header />
            <Redirect />
          </>
        }
      />
      <Route
        path="/tutorials"
        element={
          <>
            <Header />
            <VideosPage />
          </>
        }
      />
    </Routes>
  );
}

export default App;
